<template>
  <div class="kdx-news-content">
    <div class="nav-crumb-top">
      <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;"></i>
      <span @click="goHome()">首页</span>/
      <span style="color:#027B52">用户注册</span>
    </div>

    <div class="register-step-flow">
      <!-- 填写账号信息 -->
      <div class="register-wrapper">
        <div class="register-main">
          <div class="mc-register-main">
            <span class="second-register-tisi">注:注册后账号角色为教师，如果需要学生账号请联系教师登录模拟考核系统创建</span>
            <div class="mc-register-mask clearfix">
              <el-form
                :model="ruleForm"
                ref="registerForm"
                :rules="rules"
                label-width="150px"
                class="new-register-form-wrappper"
              >
                <el-form-item label="单位：" prop="schoolName">
                  <el-select
                    filterable
                    clearable
                    v-model="ruleForm.schoolId"
                    placeholder="请选择单位"
                    class="form_input"
                  >
                    <el-option
                      v-for="item in schoolInfo"
                      :key="item.Id"
                      :label="item.SchoolName"
                      :value="item.Id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="姓名：" prop="name">
                  <el-input v-model="ruleForm.name" class="form_input" placeholder="请输入您的姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号(账号)：" prop="phone">
                  <el-input
                    v-model="ruleForm.phone"
                    class="form_input"
                    placeholder="请输入您的手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="verfyCode" label="验证码："> 
                    <div class="clearfix get-verfycode-con">
                      <el-input v-model="ruleForm.verfyCode" prefix-icon="wl-icon-yanzhengma1" placeholder="请输入验证码"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="身份证号：" prop="cardNumber">
                  <el-input
                    v-model="ruleForm.cardNumber"
                    class="form_input"
                    placeholder="请输入身份证号"
                    maxlength="50"
                  ></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="password">
                  <el-input
                    v-model="ruleForm.password"
                    class="form_input"
                    type="password"
                    placeholder="请输入您的密码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="surePassword">
                  <el-input
                    v-model="ruleForm.surePassword"
                    class="form_input"
                    type="password"
                    placeholder="请输入您的密码"
                  ></el-input>
                </el-form-item>
                
                <!-- <el-form-item label="手机号：" prop="phone">
                  <el-input
                    v-model="ruleForm.phone"
                    @blur="verificationMobile"
                    class="form_input"
                    placeholder="请输入您的手机号"
                  ></el-input>
                </el-form-item> -->
              </el-form>
              
              <div class="form-tip-info-wrapper">
                <div class="tip-1">请选择你所在的单位,如果没有此处<span @click="applySchool()" style="color:#3fa2ff;cursor: pointer;">申请单位</span></div>
                <div class="tip-2">请填写正确姓名。</div>
                <!-- <div class="tip-2">请填写账号，建议使用手机号为账号，以免遗忘。</div> -->
                <div class="tip-3">请填写手机号，手机号将作为登录账号使用。</div>
                <div class="tip-4">
                  <el-button v-if="show1" type="primary" @click="sendMessage()">获取验证码</el-button>
                  <el-button v-if="show2" type="primary" >{{count}}s</el-button>
                  <el-button v-if="show3" type="primary" @click="sendMessage()">重新获取验证码</el-button>
                </div>
                <div class="tip-5">请填写正确身份证号</div>
                
                <!-- <div class="tip-5">密码可在个人中心更改</div> -->
              </div>
            </div>
            
            <div class="second-register-next-btn">
              <el-button type="primary" :disabled="check" @click="register('registerForm')">立即注册</el-button>
              <!-- <div class="back-to-first" @click="backToFirst">返回上一步</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :before-close="handleClose"
               title="单位申请"
               :visible.sync="dialogFormVisible"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="60%">
      <el-form 
               label-width="150px"
               class="clearfix">
        <el-form-item label="名称：">
          <el-input v-model="fromSchoolName"
                    class="input-with-select"
                    placeholder="请输入名称"></el-input><span style="color:red;margin-left:10px">(全称)</span>
        </el-form-item>
        <el-form-item label="别名：">
          <el-input v-model="fromSchoolAlias"
                    class="input-with-select"
                    placeholder="请输入别名"></el-input><span style="color:red;margin-left:10px">(历史名称或简称)</span>
        </el-form-item>
        <el-form-item label="所属省市：">
          <el-select v-model="fromSchoolProvince"
                     class="input-with-select"
                     filterable
                     placeholder="请选择省份"
                     @change="getCityList">
            <el-option v-for="item in optionsProvince"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="fromSchoolCity"
                     class="input-with-select"
                     placeholder="请选择市">
            <el-option v-for="item in cityList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：">
          <el-select v-model="fromSchoolType"
                     class="input-with-select"
                     filterable
                     placeholder="请选择类型">
            <el-option v-for="itemSchoolType in optionsSchoolType"
                       :key="itemSchoolType.value"
                       :label="itemSchoolType.label"
                       :value="itemSchoolType.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人姓名：">
          <el-input v-model="fromContactsName"
                    class="input-with-select"
                    placeholder="请输入申请人姓名"></el-input>
        </el-form-item>
        <el-form-item label="申请人手机号：">
          <el-input v-model="phone"
                    class="input-with-select"
                    placeholder="请输入申请人手机号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary"
                   @click="sure()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示"
               :visible.sync="message_dialog"
               top="10%"
               width="50%"
               class="clearfix change-dialog-head-wrapper"
               :show-close="false">
        <div style="font-size:22px;color:red;margin-left:20px;">已提交申请</div>
      <!-- <div style="font-size:22px;color:red;margin-left:20px;">申请结果将在1个工作日内以短信的方式通知到您。</div>
      <div style="font-size:22px;color:red;margin-left:20px;">客服联系方式：qq:528947274,邮箱：528947274@qq.com</div> -->
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="message_dialog=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { MU_UPATE_AUTH} from "store/index";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        cardNumber: "",
        password: "",
        phone: "",
        userType: 2,
        surePassword: "",
        schoolId: "",
        userName:"",
        verfyCode:""
      },
      schoolInfo: [],
      rules: {
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur"
          }
        ],
        schoolId: [
          {
            required: true,
            message: "请选择单位",
            trigger: "blur"
          }
        ],
        // userName:[{
        //             required: true,
        //             message: '账号不能为空',
        //             trigger: 'blur'
        //         }],
        cardNumber: [
          {
            required: true,
            message: "身份证号不能为空",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: "blur"
          }
        ],
        surePassword: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          }
        ],
        // verfyCode: [
        //   {
        //     required: true,
        //     message: "验证码不能为空",
        //     trigger: "blur"
        //   }
        // ]
      },
      check: false,
      schoolList:[],
      show1: true,
      show2: false,
      show3: false,
      count: 60,
      verifyCode: '',
      timer:"",
      // 申报单位字段
      dialogFormVisible:false,
      fromSchoolCode: "",
      fromSchoolName: "",
      fromSchoolAlias: "",
      fromSchoolProvince: "",
      fromSchoolCity: "",
      fromSchoolType: "",
      fromContactsName: "",
      fromSchoolUrl: "",
      fromContactsPost: "",
      fromContactInformation: "",
      phone: "",
      shortMessage: "",
      fromSalesman: "",
      fromSchoolLogoUrl: "",
      // urlAliyunOSS: urlAliyunOSSThumb,
      optionsProvince: [],
      cityList: [],
      optionsSchoolType: [
          {
          value: "中职",
          label: "中职"
          },
          {
          value: "高职",
          label: "高职"
          },
          {
          value: "本科",
          label: "本科"
          },
          {
          value: "公司",
          label: "公司"
          },
          {
          value: "其他",
          label: "其他"
          }
      ],
      imageUrl: "",
      message_dialog:false
    };
  },
  props:{
    type:{
      type:String,
      default:""
    }
  },
  created() {
    this.getSchoolInfo();
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    }
  },
  methods: {
    verificationMobile() {
      var re = /^1\d{10}$/;
      if (re.test(this.ruleForm.phone)) {
        return true;
      } else {
        this.$message.warning("手机号格式不正确");
        return false;
      }
    },
    goHome() {
      this.$router.push({
        name: "xIndex"
      });
    },
    sendMessage() {
        var once = true;
        let str_ = Date.parse(new Date()) / 1000;
        let str = this.encryption(str_);
        let str1 = CryptoJS.MD5(str_ + "").toString();
        var s1 = str1.substring(0, 7);
        var s2 = str1.substring(7);
        str1 = s1 + "s" + s2;
        if (once) {
            var that = this;

            this.$http.post("/api/XOrg/XLogin/sendCode", {
                verifyInfo: that.ruleForm.phone,
                str: str,
                str1: str1
            }).then(rst => {
                if (rst.code > 0) {
                    this.$message.success(rst.msg);
                    this.verifyCode = rst.verifyCode;
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.show1 = false;
                        this.show2 = true;
                        this.show3 = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                                once = false;
                            } else {
                                this.show1 = false;
                                this.show2 = false;
                                this.show3 = true;
                                clearInterval(this.timer);
                                this.timer = null;
                                once = true;
                            }
                        }, 1000);
                    }
                } else {
                    this.$message.warning(rst.msg);
                }
            });
        }
    },
    encryption: function (str) {
      let Base64 = require("js-base64").Base64;
      return Base64.encode(str);
    },
    //获取单位列表
    getSchoolInfo() {
      var that = this;
      this.$http.post("/api/XOrg/XLogin/getSchoolInfo").then(function(rst) {
        if (rst.code > 0) {
          that.schoolInfo = rst.schoolInfo;
        }
      });
    },
    register(formName) {
      var that = this;
      if(this.ruleForm.schoolId == ""){
        this.$message.warning("请选择单位");
        return false;
      } else 
      if (this.ruleForm.password !== this.ruleForm.surePassword) {
        this.$message.warning("两次密码不一致");
        return false;
      } else {
        this.$http
          .post("/api/XOrg/XLogin/register_new", {
            userType: this.ruleForm.userType,
            userName: this.ruleForm.userName,
            cardNumber: this.ruleForm.cardNumber,
            phone: this.ruleForm.phone,
            name: this.ruleForm.name,
            schoolId: this.ruleForm.schoolId,
            password: this.ruleForm.password,
            verfyCode: this.ruleForm.verfyCode
          })
          .then(rst => {
            if (rst.code > 0) {
              // this.onSubmitNext();
              this.$message({
                message: rst.msg,
                type: "success",
                duration:5000
              });
              
              // this.isShow = false;
              that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
              that.timer = setTimeout(that.goBack, 5000);
              
            } else {
              this.$message({
                message: rst.msg,
                type: "warning"
              });
            }
          });
      }
    },
    goBack(){
      var that = this;
      if(that.type == "jdtestExam"){
        window.location.href = "http://jdmock.chinahoteledu.com/login";
      } else if(that.type == "fdtestExam"){
        window.location.href = "http://fdmock.chinahoteledu.com/login";
      }else if(that.type == "train"){
        window.location.href = "http://tea.chinahoteledu.com/login";
      }else{
        that.goHome();
      }
      clearTimeout(that.timer);
    },
    // 申请单位
    applySchool() {
          this.$http.post("/api/XOrg/District/getProvinceList", {
          }).then(rst => {
              this.optionsProvince = rst.province;
              this.dialogFormVisible = true;
          });
      },
      sure() {
        

          var that = this;
          this.$http.post("/api/XOrg/XLogin/applySchool", {
              SchoolId:this.fromSchoolId,
              SchoolCode:this.fromSchoolCode,
              SchoolName:this.fromSchoolName,
              SchoolAlias:this.fromSchoolAlias,
              SchoolProvince:this.fromSchoolProvince,
              SchoolCity:this.fromSchoolCity,
              SchoolType:this.fromSchoolType,
              ContactsName:this.fromContactsName,
              ContactsPost:this.fromContactsPost,
              ContactInformation:this.fromContactInformation,
              Salesman:this.fromSalesman,
              SchoolLogoUrl:this.fromSchoolLogoUrl,
              SchoolUrl:this.fromSchoolUrl,
              applyBy:"register",
              phone:this.phone,
              shortMessage:this.shortMessage,
              systemSource:"3"
          }).then(rst => {
              if (rst.code > 0) {
                  that.dialogFormVisible = false;
                  that.cancel();
                  that.message_dialog = true;
                  that.$message.success(rst.msg);
                  that.getSchoolList();
              } else {
                  that.$message.warning(rst.msg);
              }
          });
      },
      cancel() {
          this.fromSchoolId = "";
          this.fromSchoolCode = "";
          this.fromSchoolName = "";
          this.fromSchoolAlias = "";
          this.fromSchoolProvince = "";
          this.fromSchoolCity = "";
          this.fromSchoolType = "";
          this.fromContactsName = "";
          this.fromSchoolUrl = "";
          this.fromContactsPost = "";
          this.fromContactInformation = "";
          this.phone = "";
          this.fromSalesman = "";
          this.shortMessage = "";
          this.dialogFormVisible = false;
      },
      handleClose() {
          this.cancel();
      },
      // 获取城市 省市联动
      getCityList(){
          this.$http.post("/api/XOrg/District/getCityList", {
              province:this.fromSchoolProvince
          }).then(rst => {
              if (rst.code > 0) {
                  this.cityList = rst.cityList;
              }
          });
      },
  }
};
</script>

<style lang="scss">
.kdx-news-content {
  height: 100%;
  margin: 0 auto;
  .nav-crumb-top {
    width: 1200px;
    margin: 18px auto 18px;
    font-size: 12px;
    color: #333333;
  }
  .register-step-flow {
    width: 1198px;
    height: 700px;
    border: 1px solid #f0f0f0;
    margin: 0 auto 55px;
  }
  .register-wrapper {
    height: 650px;
  }
  .register-main {
    margin: 0 auto;
    margin-top: 20px;
    padding: 20px 20px;
    width: 740px;
    margin-bottom: 100px;
    .register-logo {
      width: 100%;
      text-align: center;
    }
    .mc-register-mask {
      .new-register-form-wrappper {
        float: left;
        width: 383px;
        .el-form-item__label {
          margin-top: 10px;
        }
        .el-input__inner {
          width: 282px;
          background-color: #f0f0f0;
          border: 1px solid #cccccc;
          color: #666666;
        }

        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #cccccc;
        }
        input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #cccccc;
        }
        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #cccccc;
        }
        input:-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #cccccc;
        }
      }
      .mc-select {
        position: relative;
        .wl-icon-xuexiao {
          position: absolute;
          top: 21px;
          left: 6px;
          z-index: 1000;
          color: #c0c4d0;
        }
        .el-select {
          width: 100%;
          .el-input {
            .el-input__inner {
              padding-left: 30px;
            }
          }
        }
      }
      .el-input {
        margin: 10px 0;
      }
      .registerBtn {
        margin: 10px 0;
        width: 100%;
        background-color: #18a67e;
        color: white;
      }
      .registerInfo {
        margin-top: 10px;
        width: 100%;
        .reCon {
          float: left;
          a {
            color: #18a67e;
          }
        }
        .forget-pass {
          float: right;
        }
      }
      .registerInfo:after {
        content: "";
        height: 0;
        display: block;
        clear: both;
        visibility: hidden;
      }
      .qu-register {
        position: relative;
        margin-top: 40px;
        width: 100%;
        height: 40px;
        div:first-child {
          margin-top: 10px;
          width: 100%;
          height: 0;
          border-top: 1px solid gray;
        }
        div:last-child {
          position: absolute;
          top: -5px;
          left: 50%;
          margin-left: -70px;
          background-color: white;
          width: 140px;
          text-align: center;
          color: gray;
        }
      }
      .wx-register {
        text-align: center;
        color: #18a67e;
        i {
          font-size: 40px;
        }
      }
    }
    .register_wx {
      .qu-register {
        position: relative;
        margin-top: 40px;
        width: 100%;
        height: 40px;
        div:first-child {
          margin-top: 10px;
          width: 100%;
          height: 0;
          border-top: 1px solid gray;
        }
        div:last-child {
          position: absolute;
          top: -5px;
          left: 50%;
          margin-left: -70px;
          background-color: white;
          width: 140px;
          text-align: center;
          color: gray;
        }
      }
      .wx-register {
        text-align: center;
        color: #18a67e;
        i {
          font-size: 40px;
        }
      }
    }
  }
  .form-tip-info-wrapper {
    float: right;
    width: 290px;
    color: #fc0b0b;
    .tip-1 {
      margin-top: 24px;
    }
    .tip-2 {
      margin-top: 58px;
    }
    .tip-3 {
      margin-top: 62px;
    }
    .tip-4 {
      margin-top: 53px;
    }
    .tip-5 {
      margin-top: 53px;
    }
    .tip-6 {
      margin-top: 54px;
    }
  }
  .second-register-tisi{
    margin-left: 100px;
    color: #05243D;
    font-size: 16px;
  }
  .second-register-next-btn {
    margin-left: 100px;
    width: 283px;
    .el-button {
      width: 100%;
      background: #05243D;
      border-color: #05243D;
    }
    .back-to-first {
      margin-top: 10px;
      font-size: 12px;
      color: #05243D;
      text-align: right;
      cursor: pointer;
    }
  }
}
</style>